import styled from "styled-components";
import theme from "components/shared/theme";
import { Container } from "react-bootstrap";

export const FooterSection = styled.footer`
  background-color: #171b1e;
  padding-top: 3em;
  padding-bottom: 3em;
  .container {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 0px;
    padding-right: 0px;
    justify-content: space-between;
    @media screen and (max-width: 575px) {
      padding-left: 10px;
      padding-right: 10px;
    }
    @media screen and (min-width: 1216px) {
        max-width: 1152px !important;
    }
    @media screen and (min-width: 1024px) {
        max-width: 960px;
    }
    .row {
      width: 100%;
      #stores {
        @media screen and (min-width: 992px) {
          text-align: right;
          padding-right: 0px;
        }
        div {
          @media screen and (min-width: 1200px) {
            padding-right: 0px;
          }
        }
      }
    }
  }
`;

export const FooterContainer = styled(Container)`
  display: flex;
  justify-content: center;
`

export const AfterFooter = styled.div`
  min-height: 51px;
  background-color: #0e0f12;
  color: #7b8188;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    justify-content: start;
    padding-left: 15px;
  }
`;

export const BoxContact = styled.div`
  display: flex;
  @media screen and (max-width: 992px) {
    margin-top: 20px;
  }
`;

export const BoxPages = styled(BoxContact)`
  display: flex;
  flex-flow: column;
  @media screen and (min-width: 1200px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const BoxPagesCentered = styled(BoxPages)`
  @media screen and (min-width: 768px) and (max-width: 992px) {
    text-align: center;
  }
`;

export const ContactSection = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 1.5em;
  @media screen and (min-width: 992px) and (max-width: 1200px) {
    margin-left: 0.75em;
  }
`;

export const WpImage = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 0.5em;
`;
export const WitLogo = styled.img`
  height: 50px;
  width: 50px;
  object-fit: contain;
`;

export const TitleSection = styled.span`
  color: #7b8188;
  font-weight: bold;
  font-size: 0.8em;
  font-family: Poppins, Helvetica, Arial, Lucida, sans-serif;
  margin-bottom: 0px;
`;

export const ContactInfoSpan = styled(TitleSection)`
  color: white;
  font-weight: normal;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
`;

export const SocialIcon = styled.div`
  background-color: #232a31;
  text-align: center;
  width: 4em;
  height: 4em;
  margin: 0 !important;
  border-radius: 5px;
  padding: 0.5em;
  margin-right: 0.5em !important;
  path {
    fill: white;
    :hover {
      fill: ${theme.colors.greenWit};
      cursor: pointer;
    }
  }
  :hover {
    cursor: pointer;
    path {
      fill: ${theme.colors.greenWit};
    }
  }
`;

export const ArroundIcon = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  padding: 0.6em;
  border-radius: 100%;
`;

export const StoreLogo = styled.img`
  margin-top: 5px;
  margin-bottom: 5px;
`;
